import { images } from "../../../../Assets/assetsHelper";
import "./JudgingReport.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display, fontSize, maxWidth } from "@mui/system";
import { Box, Rating, Typography, Button, Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import CircleIcon from "@mui/icons-material/Circle";
import { useEffect, useState } from "react";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import TextArea from "../../../../Components/Atoms/Inputs/TextArea/TextArea";
import { toast } from "react-toastify";
import useSave from "../../../../Hooks/useSave";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import useDelete from "../../../../Hooks/useDelete";
import { missionsURL } from "../../../../Hooks/URL";

// Utility function to calculate optimal number of rating buttons
const calculateOptimalRatingButtons = (maxValue) => {
  // Always return 5 rating buttons
  return maxValue >= 10 ? 10 : 5;
};

const AttributeRating = ({ attribute, i, setScores, scores }) => {
  const [value, setValue] = useState(null);
  const [hover, setHover] = useState(-1);

  const maxValue = attribute?.maxValue || 10;
  const optimalRatingButtons = calculateOptimalRatingButtons(maxValue);
  const divisor = maxValue / optimalRatingButtons; // Always divide maxVa lue by 5 for each point
  return (
    <>
      <TableContainer component={Paper} sx={{ marginBottom: { xs: "5px" } }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  padding: { xs: "10px 10px 4px" },
                  fontSize: { xs: "15px", md: "18px" },
                  display: { xs: "block", md: "flex" },
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                }}
              >
                {i + 1} - {attribute?.name}
                <span className="scoreSmall">
                  {attribute?.value}/{attribute?.maxValue}
                </span>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Rating
                  className="rating"
                  readOnly
                  name="hover-feedback"
                  value={
                    maxValue > 10
                      ? Math.round(attribute?.value / divisor)
                      : attribute?.value
                  }
                  icon={
                    <CircleIcon color="var(--primary)" fontSize="inherit" />
                  }
                  emptyIcon={<TripOriginIcon fontSize="inherit" />}
                  max={optimalRatingButtons}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

function JudgingReport({ loading, url, report }) {
  // console.log(report);
  const navigate = useNavigate();

  const [go, setGo] = useState(false);
  const { state } = useDelete(
    `${missionsURL}/${report?.mission?.id}/teams/${report?.team?.id}/scoring-report/${report?.id}`,
    go
  );

  useEffect(() => {
    if (state?.dataRes?.status == "success") {
      navigate(-1);
    }
  }, [state]);

  const handleEdit = () => {
    navigate(
      `/missions/${report?.mission?.id}/teams/${report?.team?.id}/scoring-report/${report?.id}/edit`
    );
  };
  return (
    <div className="mainContainer">
      {report && !loading ? (
        <div className="Cont">
          {/* Action Buttons */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              margin: "20px 0",
              gap: 2,
            }}
          >
            {!report?.absent ? (
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={handleEdit}
                sx={{
                  backgroundColor: "var(--primary)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "var(--primary)",
                  },
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Edit Report
              </Button>
            ) : (
              ""
            )}
            <Button
              variant="outlined"
              startIcon={<DeleteIcon />}
              onClick={() => {
                const confirmed = window.confirm(
                  "Are you sure you want to delete this report? This action cannot be undone."
                );
                if (confirmed) {
                  setGo(true);
                }
              }}
              sx={{
                borderColor: "#d32f2f",
                color: "#d32f2f",
                "&:hover": {
                  borderColor: "#c62828",
                  backgroundColor: "rgba(211, 47, 47, 0.04)",
                },
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Delete Report
            </Button>
          </Box>
          <Box className="missionInfoSection">
            <Grid container spacing={1}>
              {/* Basic Information */}
              <Grid item xs={12}>
                <Box className="missionSettingsHeader">
                  <h3 className="missionSettingsTitle">Basic Information</h3>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Mission Name
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.mission?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Mission Number
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.mission?.order || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Category
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.team?.category?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Age Group
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.team?.category?.ageGroup?.name || "-"}
                  </Typography>
                </Box>
              </Grid>

              {/* Team Information */}
              <Grid item xs={12}>
                <Box className="missionSettingsHeader">
                  <h3 className="missionSettingsTitle">Team Information</h3>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Team Name
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.team?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Team Code
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.team?.code || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Team ID
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.team?.id || "-"}
                  </Typography>
                </Box>
              </Grid>

              {/* Date & Time Information */}
              <Grid item xs={12}>
                <Box className="missionSettingsHeader">
                  <h3 className="missionSettingsTitle">Date & Time</h3>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Date
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.dateTime?.split("T")?.at(0) || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Time
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.dateTime?.split("T")?.at(1) || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Absent
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {report?.absent ? "Yes" : "No"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {!report?.absent ? (
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <Box className="missionInfoSection">
                <Box className="missionSettingsHeader">
                  <Typography
                    variant="h3"
                    className="missionSettingsTitle"
                    sx={{
                      fontSize: { xs: "20px", md: "25px" },
                      fontWeight: "700",
                    }}
                  >
                    Scoring Sheet
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { xs: "20px", md: "25px" },
                      fontWeight: "700",
                      color: "var(--text-primary)",
                    }}
                  >
                    Total: {report?.totalValue} / {report?.maxTotalValue}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ marginTop: "16px" }}>
                {report?.groups?.map((group, i) => (
                  <Box
                    key={i}
                    className="missionInfoSection"
                    sx={{ marginBottom: "16px" }}
                  >
                    <Box className="missionSettingsHeader">
                      <Typography
                        variant="h4"
                        className="missionSettingsTitle"
                        sx={{
                          fontSize: { xs: "17px", md: "22px" },
                          fontWeight: "600",
                        }}
                      >
                        {i + 1} - {group?.name}
                      </Typography>
                    </Box>
                    <Box sx={{ marginTop: "12px" }}>
                      {group?.attributes?.map((attribute, a) => (
                        <Box key={a} sx={{ marginBottom: "12px" }}>
                          <AttributeRating
                            attribute={attribute}
                            i={a}
                            scores={attribute?.report}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}

                <Box className="missionInfoSection">
                  <Box className="missionSettingsHeader">
                    <Typography
                      variant="h4"
                      className="missionSettingsTitle"
                      sx={{
                        fontSize: { xs: "17px", md: "22px" },
                        fontWeight: "700",
                      }}
                    >
                      {report?.groups?.length + 1} - Judge's Note:
                    </Typography>
                  </Box>
                  <Box sx={{ marginTop: "12px" }}>
                    <TextArea
                      readOnly
                      name="text"
                      placeholder={"Enter your note about this team.."}
                      classes="textAreaInputFull"
                      label="Note"
                      newValue={report?.note}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default JudgingReport;
